import * as localForage from 'localforage';
import { NetworkCallback } from '@redux-offline/redux-offline/lib/types';

/*
 * Reports network status to redux-offline, honoring the manual offline override
 * ("offlineStatusOverride" in localForage, toggled from the header menu).
 */
const reportStatus = (callback: NetworkCallback, status: boolean) => {
    localForage.getItem('offlineStatusOverride', (error, offlineStatusOverride) => {
        if (error || typeof offlineStatusOverride !== 'boolean') {
            callback(status);
        } else {
            if (offlineStatusOverride === true) {
                callback(false);
            } else {
                callback(status);
            }
        }
    });
};

/*
 * redux-offline resets `offline.online` to false on every rehydrate and relies on
 * detectNetwork to report the real status. The initial report below is what unblocks
 * the outbox after an app launch on an already-connected device — without it, queued
 * writes (work order completions, closing notes, etc.) sit unsent until the browser
 * fires a network-transition event, while the UI optimistically shows them as saved.
 */
export const detectNetwork = (callback: NetworkCallback) => {
    if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener(
            'online',
            () => {
                reportStatus(callback, true);
            },
            false
        );
        window.addEventListener(
            'offline',
            () => {
                reportStatus(callback, false);
            },
            false
        );

        // PWAs can resume from the background without a network-transition event
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                reportStatus(callback, window.navigator.onLine);
            }
        });

        reportStatus(callback, window.navigator.onLine);
    }
};
